import { useMemo } from 'react';

interface JsonLdProps {
  data: Record<string, unknown>;
}

export default function JsonLd({ data }: JsonLdProps) {
  const json = useMemo(() => JSON.stringify({
    '@context': 'https://schema.org',
    ...data,
  }), [data]);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
}